import React, {useEffect, useState} from 'react'
import {Button, Form, message, Modal, Select} from "antd";
import {searchTenant} from "../../../../services/api/apiUser";
import parseToken from "../../../../helpers/parseToken";
import {getListShortPhoneByTenant, movePhoneNumber} from "../../../../services/api/apiCustomerHub";
import {QuestionCircleOutlined} from "@ant-design/icons";

const MoveNumberModal = (props) => {
    const {arrSelected, onClearChecked, onListTenantNumber} = props;
    const [formMoveNumber] = Form.useForm();
    const decodeToken = parseToken()
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [tenants, setTenants] = useState([])
    const [shortPhones, setShortPhones] = useState([])

    const tenantsSelect = Form.useWatch('tenantId', formMoveNumber)

    const showModal = () => {
        setVisible(true);
    }

    const closeModal = () => {
        setVisible(false);
        formMoveNumber.resetFields();
    }

    const _fetchListTenant = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }
            const response = await searchTenant(payload, decodeToken.sub)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _tenants = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.id,
                }
            })

            setTenants(_tenants)
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListShortPhone = async (tenantId) => {
        try {
            const payload = {
                tenantId: parseInt(tenantId)
            }
            const response = await getListShortPhoneByTenant(decodeToken.sub, payload)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _shortPhone = data.map(item => {
                return {
                    label: item.shortPhone,
                    name: item.shortPhone,
                    value: item.shortPhone,
                }
            })

            setShortPhones([..._shortPhone])
        } catch (e) {
            message.error(e.message)
        }
    }

    const _onMoveNumber = async () => {
        setLoading(true)
        try {
            const getValues = formMoveNumber.getFieldsValue();
            const payload = {
                lstId: arrSelected.map(item => item.id),
                lstPhoneNumber: arrSelected.map(item => item.phoneNumber),
                tenantId: parseInt(getValues.tenantId?.value),
                tenantName: getValues.tenantId?.label,
                shortPhone: getValues.shortPhone
            }

            const response = await movePhoneNumber(decodeToken.sub, payload)
            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }
            setLoading(false)
            closeModal()
            message.success('Chuyển số thành công!')
            onClearChecked()
            onListTenantNumber()
        } catch (e) {
            console.log(e.message)
        }
    }

    const handleOk = async () => {
        Modal.confirm({
            title: 'Xác nhận',
            icon: <QuestionCircleOutlined/>,
            content: 'Bạn chắc chắn muốn chuyển số?',
            okText: 'Chuyển số',
            cancelText: 'Huỷ',
            onOk: _onMoveNumber
        })
    }

    useEffect(() => {
        if (visible) {
            _fetchListTenant()
        }
        // eslint-disable-next-line
    }, [visible])

    useEffect(() => {
        if (tenantsSelect?.value) {
            formMoveNumber.setFieldValue('shortPhone', '')
            _fetchListShortPhone(tenantsSelect?.value)
        }
    }, [tenantsSelect?.value])

    return (
        <>
            <button className="ButtonCustom mb-sm-0 mb-1" onClick={showModal}>Chuyển số</button>
            <Modal
                title='Chuyển số'
                className='ModalEdit'
                open={visible}
                onCancel={closeModal}
                footer={[
                    <Button key="back" type="default" onClick={closeModal}>Huỷ</Button>,
                    <Button key="submit" type="primary" htmlType='submit' form='formMoveNumber' loading={loading}>
                        Chuyển số
                    </Button>
                ]}
            >
                <Form
                    layout="vertical"
                    className='FormEdit'
                    form={formMoveNumber}
                    id='formMoveNumber'
                    onFinish={handleOk}
                >
                    <Form.Item
                        className='FormField'
                        label='Khách hàng'
                        name="tenantId"
                        rules={[
                            {
                                required: true,
                                message: 'Bắt buộc chọn khách hàng'
                            }
                        ]}
                    >
                        <Select
                            labelInValue
                            showSearch
                            allowClear
                            style={{width: '100%'}}
                            placeholder={"Chọn khách hàng"}
                            filterOption={(input, option) => (option.children).toLowerCase().includes(input.toLowerCase())}
                        >
                            {
                                tenants && tenants?.length > 0 && tenants.map((item, index) => {
                                    return <Select.Option
                                        value={item.value}
                                        key={item.value + '_' + index}
                                    >
                                        {item.label}
                                    </Select.Option>
                                })
                            }
                        </Select>
                    </Form.Item>

                    {
                        tenantsSelect?.value && <Form.Item
                            className='FormField'
                            label='Số ảo'
                            name="shortPhone"
                        >
                            <Select
                                showSearch
                                allowClear
                                style={{width: '100%'}}
                                placeholder={"Chọn số ảo"}
                                filterOption={(input, option) => (option.children).toLowerCase().includes(input.toLowerCase())}
                            >
                                {
                                    shortPhones && shortPhones?.length > 0 && shortPhones.map(item => {
                                        return <Select.Option
                                            value={item.value}
                                            key={item.value}
                                        >
                                            {item.label}
                                        </Select.Option>
                                    })
                                }
                            </Select>
                        </Form.Item>
                    }
                </Form>
            </Modal>
        </>
    )
}

export default MoveNumberModal